import ComLayout from '@/layout'

const courseRouter = {
  path: '/ai-experience',
  component: ComLayout,
  redirect: '/ai-experience',
  meta: { title: 'aiExperience' },
  children: [
    {
      path: '/ai-experience',
      component: () => import('@/views/ai-experience'),
      name: 'aiExperience',
      meta: { title: 'aiExperience' }
    }
  ]
}

export default courseRouter
